export enum TriageOutput {
    InGoodOrder = 'InGoodOrder',
    NotInGoodOrder = 'NotInGoodOrder',
}
